angular
    .module('tradersyard')
    .factory('analytic-statistics-filter', [
        '$rootScope',
        function ($rootScope) {
            var factory = {
                init: function (trading) {
                    factory.trading = trading;
                },
                aggregation: 'month',
                group: null,
                trading: {},
                lastDates: {},
                collection: {},
                filtrate: function (start, end, data, go) {
                    // [TY-1820]: change analytics date from 1970 to last 5 years, to prevent long loading
                    // start = new Date() - 5 * 24 * 60 * 60 * 1000;
                    const DAY_MS = 24 * 60 * 60 * 1000;
                    start = new Date(new Date(
                        end || new Date()
                    ) - 5 * 365 * DAY_MS).toISOString().slice(0, 10);

                    if (go) {
                        var index = $aggregations.indexOf(factory.aggregation);
                        switch (go) {
                            case 'next':
                                ++index;
                                if (index === $aggregations.length) return;

                                factory.aggregation = $aggregations[index];
                                $rootScope.$broadcast('analytic-statistics-update', start, end);
                                break;
                            case 'prev':
                                --index;
                                if (index < 0) return;

                                factory.aggregation = $aggregations[index];
                                if (factory.aggregation === 'month') {
                                    $rootScope.$broadcast(
                                        'analytic-statistics-update',
                                        factory.trading.start,
                                        factory.trading.end
                                    );
                                } else {
                                    var $aggregation = $steps[$groups[$groups[factory.aggregation]]];
                                    $rootScope.$broadcast(
                                        'analytic-statistics-update',
                                        moment(factory.lastDates.start).startOf($aggregation).format('YYYY-MM-DD'),
                                        moment(factory.lastDates.end).endOf($aggregation).format('YYYY-MM-DD')
                                    );
                                }
                                break;
                        }
                        return;
                    }

                    factory.group = factory.aggregation;

                    var $default_schema = schema(start, factory.aggregation);
                    var $range = range(start, end, $groups[factory.aggregation], 'base');
                    var $collection = {
                        schema: $default_schema,
                        interval: {
                            start: start,
                            end: end,
                        },
                        default: true,
                    };

                    for (var $group in $range) {
                        var $item = $range[$group];
                        $item.items = 0;
                        $item.sum = 0;
                        var $schema = range($item.start, $item.end, factory.aggregation, 'child');
                        $item.length = Object.keys($schema).length;

                        for (var aggregation in $schema) {
                            var date = $schema[aggregation];

                            if ($collection.default === true)
                                if (schemaDifference($default_schema, $schema)) $collection.default = false;

                            if (data) {
                                for (var i = 0; i < data.length; ++i) {
                                    var $trade = data[i];
                                    var item_date = moment($trade[0]).tz('UTC');
                                    if (
                                        item_date.isBetween(date.start, date.end) ||
                                        item_date.format('YYYY-MM-DD') === date.start ||
                                        item_date.format('YYYY-MM-DD') === date.end
                                    ) {
                                        date.data = { date: $trade[0], pl: $trade[1], open: $trade[2] };
                                        ++$item.items;
                                        $item.sum += $trade[1];
                                    }
                                }
                            }
                        }
                        $item.schema = $schema;
                    }
                    $collection.data = $range;

                    factory.collection = $collection;

                    factory.expanded = {
                        count: 0,
                        state: false,
                    };

                    factory.lastDates = {
                        start: start,
                        end: end,
                    };
                },
                expanded: {
                    count: 0,
                    state: false,
                },
                minimize: function () {
                    factory.expanded.state = !factory.expanded.state;
                },
                formats: {
                    year: 'YYYY',
                    month: 'MMM',
                    week: 'WW',
                    day: 'ddd',
                },
            };

            $rootScope.$on('$locationChangeStart', function (e) {
                if ($aggregations.indexOf(factory.aggregation) === 0) return;

                factory.filtrate(undefined, undefined, undefined, 'prev');
                e.preventDefault();
            });

            var $steps = {
                    year: 'year',
                    month: 'month',
                    week: 'isoWeek',
                    day: 'day',
                },
                $groups = {
                    month: 'year',
                    week: 'month',
                    day: 'week',
                },
                $aggregations = ['month', 'week', 'day'];

            function schema(date, aggregation) {
                var $aggregation = $steps[$groups[aggregation]],
                    $start = moment(date).startOf($aggregation),
                    $end = moment(date).endOf($aggregation),
                    $schema = {};

                while ($end.diff($start, aggregation, true) > 0.0) {
                    var format = factory.formats[aggregation];
                    $schema[$start.format(format)] = {};
                    $start = $start.add(1, aggregation);
                }

                return $schema;
            }

            function range(start, end, aggregation, base) {
                var $range = {},
                    $aggregation = $steps[aggregation],
                    $start = moment(start).startOf($aggregation),
                    $end = moment(end).endOf($aggregation);

                while ($end.diff($start, aggregation, true) > 0.0) {
                    var format = factory.formats[aggregation],
                        _start = $start.format('YYYY-MM-DD'),
                        _end = moment($start.format('YYYY-MM-DD')).endOf($aggregation).format('YYYY-MM-DD'),
                        key = $start.format(format);
                    switch (base) {
                        case 'base':
                            if (aggregation === 'week')
                                key = moment(_start).format('DD.MM') + ' - ' + moment(_end).format('DD.MM');
                            break;
                        case 'child':
                            if (aggregation === 'week') key = moment(_start).format('DD.MM');
                            break;
                    }

                    $range[key] = {
                        start: _start,
                        end: _end,
                    };
                    $start = $start.add(1, aggregation);
                }

                return $range;
            }

            function schemaDifference(obj1, obj2) {
                for (var key in obj1) {
                    if (obj2[key] === undefined) return true;
                }
                return false;
            }

            return factory;
        },
    ])
    .factory('analytic-chart-factory', [
        'analytic-statistics-filter',
        function ($filter) {
            var factory = {
                data: {},
                convertible: {
                    leader_board_trading_performance: 'leaderBoardPerformanceChart',
                    trading_performance: 'performanceChart',
                    cumulative_performance: 'cumulativeChart',
                    aggregation_performance: 'aggregationChart',
                    trading_instrument_type: 'basicChart',
                    trading_symbol: 'basicChart',
                    trading_strategies: 'basicChart',
                    trading_time_frame: 'basicChart',
                    short_won: 'directionChart',
                    long_won: 'directionChart',
                    preview: 'preview',
                },
                graphics: {
                    basicChart: {
                        x: function () {
                            return function (d) {
                                var s = d.entry !== null ? d.entry : 'null',
                                    f = s.charAt(0).toUpperCase();
                                d.entry = f + s.substr(1, s.length - 1);

                                return d.entry;
                            };
                        },
                        y: function () {
                            return function (d) {
                                return d.trades;
                            };
                        },
                        tooltipContent: function () {
                            return function (y, e, graph) {
                                var item = graph.point;

                                var html = '<h3>' + y + ' (' + e + ')</h3>';

                                if (item.profitable !== undefined)
                                    html += '<p>P/L: ' + d3.format(',.2f')(item.profitable * 100) + ' %</p>';
                                if (item.profitable_trades !== undefined)
                                    html +=
                                        '<p>Winning trades: ' +
                                        d3.format(',.2f')((item.profitable_trades / item.trades) * 100) +
                                        ' %</p>';
                                if (item.avg_profit !== undefined)
                                    html += '<p>Avg. Profit: ' + d3.format(',.2f')(item.avg_profit * 100) + ' %</p>';
                                if (item.avg_loss !== undefined)
                                    html += '<p>Avg. Loss: ' + d3.format(',.2f')(item.avg_loss * 100) + ' %</p>';

                                return html;
                            };
                        },
                        data: function ($data) {
                            if ($data === undefined) return;
                            var other = 0,
                                obj = {};

                            if ($data.length > 0) {
                                other = $data[0].total_trades;

                                $data.forEach(function (item) {
                                    other -= item.trades;
                                });

                                obj.entry = 'Other';
                                obj.trades = other;

                                if (other > 0) $data.push(obj);
                            }

                            return $data;
                        },
                        color: function () {
                            return function (d, i) {
                                var colors = [
                                    'rgb(15, 52, 86)',
                                    'rgb(145, 15, 15)',
                                    'rgb(14, 91, 85)',
                                    'rgb(29, 133, 203)',
                                    'rgb(40,40,40)',
                                    'rgb(55,169,10)',
                                ];
                                return d3.rgb(colors[i % colors.length]);
                            };
                        },
                        legendColor: function () {
                            return function (d, i) {
                                var colors = [
                                    'rgb(15, 52, 86)',
                                    'rgb(145, 15, 15)',
                                    'rgb(14, 91, 85)',
                                    'rgb(29, 133, 203)',
                                    'rgb(40,40,40)',
                                    'rgb(55,169,10)',
                                ];
                                return d3.rgb(colors[i % colors.length]);
                            };
                        },
                    },
                    directionChart: {
                        x: function () {
                            return function (d) {
                                var s = d.direction !== null ? d.direction : 'null',
                                    f = s.charAt(0).toUpperCase();
                                d.direction = f + s.substr(1, s.length - 1);

                                return d.direction;
                            };
                        },
                        y: function () {
                            return function (d) {
                                return d.profitable;
                            };
                        },
                        tooltipContent: function () {
                            return function (y, e) {
                                return '<h3>' + y + ': ' + e + '</h3>';
                            };
                        },
                        data: function ($data) {
                            if ($data === undefined) return;
                            var obj = {},
                                output = [];

                            $data.direction = 'Win';
                            obj.direction = 'Loss';
                            obj.profitable = $data.trades - $data.profitable;

                            output.push($data);
                            if ($data.trades - $data.profitable > 0) output.push(obj);

                            return output;
                        },
                        color: function () {
                            return function (d, i) {
                                var colors = ['rgb(55,169,10)', 'rgb(40,40,40)'];
                                return d3.rgb(colors[i % colors.length]);
                            };
                        },
                        legendColor: function () {
                            return function (d, i) {
                                var colors = ['rgb(55,169,10)', 'rgb(40,40,40)'];
                                return d3.rgb(colors[i % colors.length]);
                            };
                        },
                    },
                    performanceChart: {
                        xAxisTickFormat: function () {
                            return function (d) {
                                const d1 = new Date();
                                const d2 = new Date(d);

                                if (d1 < d2) {
                                    return 'Open';
                                }

                                if (d2.getMonth() === 0) {
                                    return moment(d).format('YYYY-MMM');
                                }

                                return moment(d).format($filter.formats[$filter.aggregation]);
                            };
                        },
                        yAxisTickFormat: function () {
                            return function (d) {
                                return d3.format(',.2f')(d * 100) + ' %';
                            };
                        },
                        valueFormat: function () {
                            return function (d) {
                                return d3.format(',.2f')(d * 100);
                            };
                        },
                        data: function ($data) {
                            if ($data === undefined) return;
                            var result = { values: [], items: $data.length };

                            $data.forEach(function (item) {
                                result.values.push([item.entry, item.pl, item.open]);
                            });

                            return [result];
                        },
                        color: function () {
                            return function (d) {
                                if (d[2]) {
                                    return d3.rgb(255, 165, 0);
                                }

                                return d[1] < 0 ? d3.rgb(145, 15, 15) : d3.rgb(55, 169, 10);
                            };
                        },
                    },
                    leaderBoardPerformanceChart: {
                        xAxisTickFormat: function () {
                            return function (d) {
                                return d3.time.format('%Y-%m-%d')(new Date(d));
                            };
                        },
                        yAxisTickFormat: function () {
                            return function (d) {
                                return d3.format(',.2f')(d * 100) + ' %';
                            };
                        },
                        valueFormat: function () {
                            return function (d) {
                                return d3.format(',.2f')(d * 100);
                            };
                        },
                        data: function ($data) {
                            if ($data === undefined) {
                                return;
                            }

                            let histResults = [],
                                closeResults = [],
                                openShowResults = [],
                                openResults = [],
                                pl = 0;

                            $data.forEach(function (item) {
                                if (item.open === undefined) {
                                    histResults.push([moment(item.entry), (pl += item.pl), item.open]);
                                }

                                if (item.open === true) {
                                    const nowDate = new Date();

                                    if ($data[$data.length - 2]) {
                                        openResults.push([moment($data[$data.length - 2].entry), pl]);
                                        closeResults.push([moment($data[$data.length - 2].entry), pl]);
                                    } else {
                                        console.warn('No data for close')
                                        // openResults.push([moment(item.entry), pl]);
                                        // closeResults.push([moment(item.entry), pl]);
                                    }

                                    openResults.push([
                                        nowDate.setMonth(nowDate.getMonth() + 1),
                                        (pl += item.pl),
                                        item.open,
                                    ]);
                                    openShowResults.push([nowDate.setMonth(nowDate.getMonth()), pl, item.open]);
                                }
                            });

                            return [
                                {
                                    values: histResults,
                                    key: 'Hist',
                                    color: 'rgb(31, 119, 180)',
                                },
                                {
                                    values: openResults,
                                    key: 'Open',
                                    color: 'rgb(255, 165, 0)',
                                },
                                {
                                    values: closeResults,
                                    key: 'Close',
                                    color: 'rgb(76, 175, 80)',
                                },
                                {
                                    values: openShowResults,
                                    key: 'Open',
                                    color: 'rgb(255, 165, 0)',
                                },
                            ];
                        },
                    },
                    cumulativeChart: {
                        xAxisTickFormat: function () {
                            return function (d) {
                                const d1 = new Date();
                                const d2 = new Date(d);

                                if (d1 < d2) {
                                    return 'Open';
                                }

                                return d3.time.format('%Y-%m-%d')(d2);
                            };
                        },
                        yAxisTickFormat: function () {
                            return function (d) {
                                return d3.format(',.2f')(d * 100) + ' %';
                            };
                        },
                        data: function ($data) {
                            if ($data === undefined) {
                                return;
                            }

                            let histResults = [],
                                closeResults = [],
                                openShowResults = [],
                                openResults = [],
                                pl = 0;

                            $data.forEach(function (item) {
                                if (item.open === undefined) {
                                    histResults.push([moment(item.entry), (pl += item.pl), item.open]);
                                }

                                if (item.open === true) {
                                    const nowDate = new Date();

                                    if ($data[$data.length - 2]) {
                                        openResults.push([moment($data[$data.length - 2].entry), pl]);
                                        closeResults.push([moment($data[$data.length - 2].entry), pl]);
                                    } else {
                                        console.warn('No data for close')
                                        // openResults.push([moment(item.entry), pl]);
                                        // closeResults.push([moment(item.entry), pl]);
                                    }

                                    openResults.push([
                                        nowDate.setMonth(nowDate.getMonth() + 1),
                                        (pl += item.pl),
                                        item.open,
                                    ]);
                                    openShowResults.push([nowDate.setMonth(nowDate.getMonth()), pl, item.open]);
                                }
                            });

                            return [
                                {
                                    values: histResults,
                                    key: 'Hist',
                                    color: 'rgb(31, 119, 180)',
                                },
                                {
                                    values: openResults,
                                    key: 'Open',
                                    color: 'rgb(255, 165, 0)',
                                },
                                {
                                    values: closeResults,
                                    key: 'Close',
                                    color: 'rgb(76, 175, 80)',
                                },
                                {
                                    values: openShowResults,
                                    key: 'Open',
                                    color: 'rgb(255, 165, 0)',
                                },
                            ];
                        },
                    },
                    aggregationChart: {
                        yAxisTickFormat: function () {
                            return function (d) {
                                return d3.format(',.0d')(d);
                            };
                        },
                        valueFormat: function () {
                            return function (d) {
                                return d3.format(',.0d')(d);
                            };
                        },
                        tooltipContent: function () {
                            return function (key, y, e) {
                                var content =
                                    $filter.aggregation.charAt(0).toUpperCase() +
                                    $filter.aggregation.substr(1) +
                                    's: ' +
                                    e;
                                return '<p>' + content + '</p>';
                            };
                        },
                        data: function ($data) {
                            if ($data === undefined) return;
                            var result = { values: [], items: $data.length };

                            var values = {
                                '<-4%': {
                                    value: 0,
                                    interval: -4,
                                },
                                '-4/-3%': {
                                    value: 0,
                                    interval: -3,
                                },
                                '-3/-2%': {
                                    value: 0,
                                    interval: -2,
                                },
                                '-2/-1%': {
                                    value: 0,
                                    interval: -1,
                                },
                                '-1/0%': {
                                    value: 0,
                                    interval: 0,
                                },
                                '0-1%': {
                                    value: 0,
                                    interval: 1,
                                },
                                '1-2%': {
                                    value: 0,
                                    interval: 2,
                                },
                                '2-3%': {
                                    value: 0,
                                    interval: 3,
                                },
                                '3-4%': {
                                    value: 0,
                                    interval: 4,
                                },
                                '>4%': {
                                    value: 0,
                                    interval: 5,
                                },
                            };

                            $data.forEach(function (item) {
                                item.pl *= 100;
                                if (item.pl < -4) {
                                    ++values['<-4%'].value;
                                } else if (item.pl < -3) {
                                    ++values['-4/-3%'].value;
                                } else if (item.pl < -2) {
                                    ++values['-3/-2%'].value;
                                } else if (item.pl < -1) {
                                    ++values['-2/-1%'].value;
                                } else if (item.pl < 0) {
                                    ++values['-1/0%'].value;
                                } else if (item.pl < 1) {
                                    ++values['0-1%'].value;
                                } else if (item.pl < 2) {
                                    ++values['1-2%'].value;
                                } else if (item.pl < 3) {
                                    ++values['2-3%'].value;
                                } else if (item.pl < 4) {
                                    ++values['3-4%'].value;
                                } else {
                                    ++values['>4%'].value;
                                }
                            });

                            for (var index in values) {
                                result.values.push([index, values[index].value, values[index].interval]);
                            }

                            return [result];
                        },
                        color: function () {
                            return function (d) {
                                return d[2] > 0 ? d3.rgb(55, 169, 10) : d3.rgb(112, 13, 13);
                            };
                        },
                    },
                    preview: {
                        x: function () {
                            return function (d) {
                                return d[0];
                            };
                        },
                        y: function () {
                            return function (d) {
                                return d[1];
                            };
                        },
                        data: function ($data) {
                            if ($data === undefined) return;

                            var data = $data.data;
                            var output = { values: [] },
                                curr_date = moment(),
                                diff = 0,
                                pl = 0;

                            if (data.length > 0)
                                for (var week = 12, pos = 0, i = 0; week > 0; --week, ++pos) {
                                    var item = data[i];
                                    var $item_date = moment(item.date);

                                    diff = curr_date.diff($item_date, 'week', true);

                                    if (Math.round(diff) >= week) {
                                        pl = item.pl;
                                        if (data[i + 1] !== undefined) ++i;
                                    }

                                    output.values.push([pos, pl]);
                                }

                            return {
                                performance: $data.performance,
                                drawdown: $data.drawdown,
                                chart: [output],
                            };
                        },
                    },
                },
                has: function (type) {
                    return factory.graphics[factory.convertible[type]] !== undefined;
                },
                convert: function (type, data) {
                    return factory.graphics[factory.convertible[type]].data(data);
                },
            };

            return factory;
        },
    ])
    .filter('minimizeTo', [
        'analytic-statistics-filter',
        function ($filter) {
            return function (data, maxLength) {
                if (data === undefined) return;

                if (!maxLength || $filter.expanded.state) return data;

                var visible = 0,
                    total = 0,
                    output = {};
                for (var entry in data) {
                    if (data[entry].items > 0) {
                        ++total;
                        if (total <= maxLength) {
                            ++visible;
                            output[entry] = data[entry];
                        }
                    }
                }

                $filter.expanded.count = total - visible;

                return output;
            };
        },
    ])
    .controller('analytic-statistics-ctrl', [
        '$scope',
        'graph-analytic-factory',
        'analytic-statistics-filter',
        'analytic-chart-factory',
        '$location',
        function ($scope, $factory, $filter, $chart, $location) {
            const preselectedAccount = parseInt($location.search().account);

            $scope.empty = true;
            $scope.process = false;
            $scope.loader = false;
            $scope.space = 'me';
            $scope.filter = $filter;
            $scope.chart = $chart;
            $scope.charts = {};
            $scope.params = {
                ...(preselectedAccount ? { account_id: preselectedAccount } : {})
            };

            $scope.init = function ($space) {
                if ($space) {
                    $scope.space = $space;
                }

                $scope.dates();
            };

            $scope.$entryLeaderBoard = function (data) {
                $scope.setData(JSON.parse(data), 'leader_board_trading_performance');
            };

            $scope.$entry = function ($space) {
                if ($space) $scope.space = $space;

                $scope.$on('analytic-statistics-init', function () {
                    $scope.dates(preselectedAccount ? preselectedAccount : 'main');
                });

                $scope.$on('analytic-account-select', function (e, accountId) {
                    $scope.portfolio = [];
                    $scope.params = angular.extend($scope.params, {
                        page: 0,
                        account_id: accountId,
                    });
                    $scope.charts = {};
                    $scope.filter.collection = {};
                    $scope.empty = true;
                    $scope.dates(accountId);
                });
            };

            $scope.$on('analytic-statistics-update', function (e, start, end) {
                $scope.find(start, end);
            });

            $scope.filtrate = function (start, end, go) {
                $scope.filter.filtrate(start, end, $scope.charts.trading_performance[0].values, go);
            };

            $scope.find = function (start, end) {
                $scope.loader = true;
                $scope.params = angular.extend($scope.params, {
                    aggregation_perido: $scope.filter.aggregation,
                    start: start,
                    end: end,
                });
                $factory.statistics($scope.space, { params: $scope.params }).then(function ($response) {
                    if ($response.data.state === 0) {
                        for (var type in $response.data.data) {
                            $scope.charts[type] = $scope.chart.has(type)
                                ? $scope.chart.convert(type, $response.data.data[type])
                                : $response.data.data[type];

                            if ($scope.empty && $response.data.data[type].length > 0) {
                                $scope.empty = false;
                            }
                        }

                        $scope.filtrate(start, end);
                    }

                    $scope.loader = false;
                    $scope.process = true;
                });
            };

            $scope.dates = function (accountId) {
                $factory.dates($scope.space, accountId).then(function ($response) {
                    if ($response.data.state === 0) {
                        if ($response.data.data.start === null || $response.data.data.end === null) {
                            $scope.process = true;
                            return;
                        }

                        $scope.trading = $response.data.data;
                        $scope.filter.init($scope.trading);
                        $scope.find($scope.trading.start, $scope.trading.end);
                    }
                });
            };

            $scope.setData = function (data, type) {
                $scope.charts[type] = $scope.chart.convert(type, data);
            };
        },
    ]);
